import { Heading } from 'blaze-ui/Heading/Heading'
import { FieldArray, useField } from 'formik'
import { Source } from 'types'
import { ContextTable } from 'screens/Campaign/CampaignContext/ContextTable'
import Styles from './Sources.module.scss'
import { AddWebpageButton } from 'screens/Campaign/CampaignContext/AddWebpageModal/AddWebpageButton'
import { UploadButton } from 'screens/Campaign/CampaignContext/UploadButton'
import { EmptySources } from 'screens/Campaigns/components/AddCampaignModal/CreateCampaign/EmptySources'

export const Sources = () => {
  const [field] = useField<Source[]>('sources')
  return (
    <>
      <FieldArray name="sources">
        {({ push, remove }) => (
          <>
            <div className={Styles.header}>
              <Heading level={4}>Campaign context</Heading>
              {field.value.length > 0 && (
                <div className={Styles.addMoreContextButton}>
                  <AddWebpageButton variant="ghost" onSourceCreated={push} />
                  <UploadButton variant="ghost" onSourceCreated={push} />
                </div>
              )}
            </div>
            {field.value.length < 1 && <EmptySources onSourceCreated={push} />}
            {field.value.length > 0 && (
              <ContextTable
                sources={field.value}
                isLoading={false}
                onSourceCreated={push}
                onDeleteSource={(source) =>
                  remove(field.value.findIndex((fieldSource) => fieldSource.id === source.id))
                }
              />
            )}
          </>
        )}
      </FieldArray>
    </>
  )
}
